import React from 'react';

import { GUIDE_TEXT_MAX_WIDTH } from '@backrs_ui/grow-ui/src/components/GuidePage';
import type { CommonAppEssayFinalRealityCheck } from '@backrs_ui/grow-ui/src/pages/CommonAppEssayGuide/content/types';

import { SxProps, Theme, Typography } from '@mui/material';

type FinalRealityCheckSectionProps = Readonly<{
  content: CommonAppEssayFinalRealityCheck;
}>;

export const FinalRealityCheckSection: React.FC<FinalRealityCheckSectionProps> = ({ content }) => (
  <Typography variant="text-md-regular" sx={bodySx}>
    {content.body}
  </Typography>
);

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
  pb: backrs.spacing['spacing-4xl'],
});
